import APIClient from '@/shared/http/clients/api'

const resourceName = 'endividamento'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=periodoMovimento,desc`, config)
const SearchEndvidamento = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=periodoMovimento,desc`, config)
const SearchSFN = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}-sfn/?document=${document}&page=${index}&size=${limit}&sort=periodoMovimento,desc`, config)

/**
 * @name IndebtednessRepository
 * @description Endividamento
 * @type { Respository }
 */
const IndebtednessRepository = {
  Search,
  SearchEndvidamento,
  SearchSFN
}

export default IndebtednessRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/indebtedness.js